module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDI0IDI0Ij4KPHN0eWxlPgogICAgLnBhdGgxIHsgZmlsbDogIzAyMDIwMjsgfQo8L3N0eWxlPgo8cGF0aCBjbGFzcz0icGF0aDEiIGQ9Ik0xMiAxMi43MTNsLTExLjk4NS05LjcxM2gyMy45N2wtMTEuOTg1IDkuNzEzem0wIDIuNTc0bC0xMi05LjcyNXYxNS40MzhoMjR2LTE1LjQzOGwtMTIgOS43MjV6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/about/email.svg
// module id = 684
// module chunks = 263791100135453